export const model = (canvas) => {

    if(canvas){

        const ctx = canvas.getContext('2d');
        const sprite1 = new Image();
        const sprite2 = new Image();

        const coef = Number(canvas.dataset.coef);
        
        sprite1.src = canvas.dataset.spriteFirst;
        sprite2.src = canvas.dataset.spriteSecond;

        
        const spriteWidth = Number(canvas.dataset.spriteWidth); // Ширина каждого кадра в спрайте
        const spriteHeight = Number(canvas.dataset.spriteHeight); // Высота каждого кадра в спрайте
        
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        
        let currentSprite = sprite1;
        let frameIndex = 0;
    
        const framesInSprite1 = Number(canvas.dataset.countSprite); // Общее количество кадров в первом спрайте
        const framesInSprite2 = Number(canvas.dataset.countSprite); // Общее количество кадров во втором спрайте
    
    
        let totalFrames = framesInSprite1 + framesInSprite2; // Общее количество кадров в анимации
        const animationSpeed = canvas.dataset.animationSpeed;; // Скорость анимации
        let forward = true; // Флаг для определения направления анимации
        
        Promise.all([loadImage(sprite1), loadImage(sprite2)])
        .then(() => {
            console.log("Загрузили");
           
            // Изображения загружены, начинаем анимацию
            setTimeout(function() {
                animate();
                canvas.classList.remove('animationCanvas--preview');
                canvas.classList.add('animationCanvas--runner');

            }, 10);
    
        })
        .catch(() => {
            // Если произошла ошибка загрузки изображений, отображаем первый кадр первого спрайта
           // ctx.drawImage(preview, 0, 0, spriteWidth, spriteHeight, 0, 0, canvasWidth, canvasHeight);
        });
    
        function loadImage(img) {
        return new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
        });
        }
    

        
        let displayWidth = spriteWidth * coef;
        let displayHeight = spriteHeight * coef;
    
        // Рассчитываем координаты отображения
        let offsetX = (canvasWidth - displayWidth) / 2;
        let offsetY = (canvasHeight - displayHeight) / 2;

        function animate() {
            
            // Рассчитываем размер отображаемой области
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            
            currentSprite = (frameIndex >= framesInSprite1) ? sprite2 : sprite1;

            let currentPosY =  ((frameIndex) % framesInSprite1) * spriteHeight;
            //console.log(currentPosY);
            
            //console.log(frameIndex * spriteHeight);
            // Отображаем только часть текущего спрайта в центре холста
            ctx.drawImage(
                currentSprite, 
                0, currentPosY, spriteWidth, spriteHeight,
                offsetX, offsetY, displayWidth, displayHeight
            );
            // Увеличиваем или уменьшаем frameIndex в зависимости от направления анимации
            if (forward) {
                frameIndex++;
            } else {
                frameIndex--;
            }
    
            // Переключаемся между спрайтами в конце каждого цикла анимации
            if (frameIndex >= totalFrames) {
                forward = false;
                frameIndex = totalFrames-1;
                
            } else if (frameIndex <= 0) {
                forward = true;
                frameIndex = 0;
            }
    

            // Продолжаем анимацию
           // requestAnimationFrame(animate);
            setTimeout(animate, 100 / animationSpeed);
        }
        // Запускаем анимацию
    }
    
}